import React from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { setParameters } from "../../shared/store/actions/advisor";
import ParametersWebUI from "../../components/Advisor/Parameters";

class Parameters extends React.Component {
  updateParameters = (parameter, value) => {
    const parameters = Object.assign({}, this.props.parameters, {
      [parameter]: value
    });

    this.props.setParameters(parameters);
  };

  submitParameters = () => {
    this.props.history.push("/results");
  };

  render() {
    return (
      <ParametersWebUI
        advisor={this.props.advisor}
        humidity={this.props.parameters.humidity}
        temperature={this.props.parameters.temperature}
        snowType={this.props.parameters.snowType}
        onUpdate={this.updateParameters}
        onSubmit={this.submitParameters}
      />
    );
  }
}

const mapStateToProps = state => ({
  parameters: state.advisor.parameters,
  advisor: state.advisor
});

export default connect(
  mapStateToProps,
  { setParameters }
)(
  withNamespaces(["parameters", "common"], { wait: true })(
    withRouter(Parameters)
  )
);
